export default __webpack_public_path__ + "static/media/trash.7bbecc37.gif";